import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';

// ACTION CREATORS
export const programBase = () => ({ type: ACTION.PROGRAM_BASE });
export const programQuery = () => ({ type: ACTION.PROGRAM_QUERY });
export const isLibraryLoading = () => ({ type: ACTION.LIBRARY_LOADING });
export const libraryLoaded = (programs = [], totalCount = null, query = '') => ({ type: ACTION.LIBRARY_LOADED, programs, totalCount, programType: 'standard', query });
export const draftsLoaded = (draftPrograms = [], totalCount = null, query = '') => ({ type: ACTION.LIBRARY_LOADED, programs: draftPrograms, totalCount, programType: 'drafts', query });
export const programsLoaded = (programs = [], totalCount = null, programType = 'standard', query = '', specialType = null) => ({ type: ACTION.LIBRARY_LOADED, programs, totalCount, programType, query, specialType });
export const isFilterLoading = () => ({ type: ACTION.FILTER_LOADING });
export const filterLoaded = (filters = {}) => ({ type: ACTION.FILTER_LOADED, filters });
export const programUpdating = () => ({ type: ACTION.PROGRAM_UPDATING });
export const programError = (error) => ({ type: ACTION.PROGRAM_ERROR, error });

export const getProgramLibrary = (params, programType) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isLibraryLoading());
    apiService.getPrograms(params)
    .then(response => {
      dispatch(programsLoaded(response.results, response.count, programType));
      resolve(response);
    })
    .catch(error => {
      dispatch(programBase());
      reject(error);
    });
  });
}
export const getWellnessPrograms = (programType) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isLibraryLoading());
    apiService.getWellnessPrograms()
    .then(response => {
      dispatch(programsLoaded(response, response.count, programType, null, "wellnessUnAssignedPrograms"));
      resolve(response);
    })
    .catch(error => {
      dispatch(programBase());
      reject(error);
    });
  });
}

export const addProgramSet = (id, params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(programUpdating());
    apiService.createProgramSet(id, params)
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      dispatch(programError(error));
      reject(error);
    });
  });
}

export const getProgramAggregate = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isFilterLoading());
    params.endpoint = 'programs';
    apiService.getAggregate(params)
    .then(response => {
      const programState = getState().programState;
      let filters = Object.assign({}, programState.filters);
      filters[params.type] = response[params.type];
      dispatch(filterLoaded(filters));
      resolve(response);
    })
    .catch(error => {
      dispatch(programBase());
      reject(error);
    });
  });
}
